import DynamicCarrierField from './styled';

export default DynamicCarrierField;
